import Http from '../services/http.js'
import BaseApi from "@api/base.api";

export default class DocumentCategoryMappingApi extends BaseApi {
  static get entity() {
    return 'document-category-mappings'
  }
  
  static async getMappings(params = {}) {
    return Http.get(`${this.entity}`, params)
  }
 
  static async createMapping(data) {
    return Http.post(`${this.entity}`, data)
  }
 
  static async getMapping(id) {
    return Http.get(`${this.entity}/${id}`)
  }
 
  static async updateMapping(id, data) {
    return Http.put(`${this.entity}/${id}`, data)
  }
 
  static async deleteMapping(id) {
    return Http.delete(`${this.entity}/${id}`)
  }
 
  static async getCategories() {
    return Http.get(`${this.entity}/categories/list`)
  }
 
  static async getDocumentTypesByCategory(category) {
    return Http.get(`${this.entity}/categories/${category}/document-types`)
  }
 
  static async getAllDocumentTypes() {
    return Http.get(`${this.entity}/document-types/all`)
  }
}